/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Button, Col, Container, Row, Table } from 'react-bootstrap';
import {
  FaBars,
  FaMinusCircle,
  FaPencilAlt,
  FaPlusCircle,
  FaPrint,
  FaSpinner,
  FaTrashAlt,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import OdontoGrama from './OdontoGrama';
import { IProcedimentoAgendamento } from '../../../components/Agendamento';
import { useToast } from '../../../hooks/toast';
import Loading from '../../../components/Loading';
import Modal from '../../../components/Modal';
import { Spinner } from '../../../components/Agendamento/styles';
import {
  formataCPF,
  formataIdade,
  formataTelefone,
  formatPrice,
  STATUS_AGENDA,
  TIPO_PAGAMENTO,
  TIPO_TRATAMENTO,
} from '../../../utils/funcoes';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import AgendamentosTratamento from './AgendamentosTratamento';
import getResponseErrors from '../../../utils/getResponseErrors';
import Evolucao from './Evolucao';
import SelectAsync from '../../../components/SelectAsync';
import { IPacienteCodigo } from '..';
import ModalAssinaturaContrato, {
  IPacienteContrato,
} from './ModalAssinaturaContrato';

// type WithChildren<T = {}> = T & { children?: React.ReactNode };

export interface ITratamentoDente extends IProcedimentoAgendamento {
  dente: string;
  chave: string;
  finalizado?: boolean;
  procedimentoEvolucao?: IProcedimentoEvolucao[];
  id?: number;
}

export interface IProcedimentoEvolucao {
  id: number;
  idProcedimento: number;
  MedUsuCodigo: number;
  texto: string;
  created_at: Date;
  dataFormatada?: string;
}

interface IProcedimentosValor {
  ProAgeCodigo: number;
  ProProCodigo: number;
  ProValor: number;
}
export interface IAgenda {
  AgeCodigo: number;
  AgeConfCodigo: number;
  AgeInicio: Date;
  AgeStatus: number;
  updated_at: Date;
  procedimentosValorCobrado: IProcedimentosValor[];
}

export interface IOrcamento {
  id: number;
  PacCodigo: number;
  PacCodigoResponsavel: number;
  MedUsuCodigo: number;
  AgeCodigo: number;
  plano: boolean;
  valor: number;
  tipo: number;
  secoes: number;
  orcamento: boolean;
  finalizado: boolean;
  formaPagamento: string;
  validade: Date;
  procedimentosTratamento: [
    {
      id: number;
      idTratamento: number;
      ProCodigo: number;
      ProNome: string;
      dente: string;
      valor: number;
      finalizado: boolean;
      procedimentoEvolucao: IProcedimentoEvolucao[];
    },
  ];
  contrato?: IContrato;
  agendamentosTratamento: {
    AgeCodigo: number;
    idTratamento: number;
    agenda: IAgenda;
  }[];
  medico: {
    UsuCodigo: number;
    UsuNome: string;
    UsuEmail: string;
  };
}

interface IContrato {
  ConCodigo: number;
  ConAssinado: boolean;
  ConArquivo: string;
  ConExternalId: string;
  arquivo_url?: string;
}

interface IDadosAgendamento {
  pacienteID: number;
  agePlano: boolean;
  AgeCodigo: number;
}

type IProps = {
  paciente: IPacienteContrato;
  dadosAgendamento: IDadosAgendamento;
  medUsuCodigo?: number;
  finalizado?: boolean;
  buscaOutrosMedicos: boolean;
  bloqueado: boolean;
  idTratamento?: number;
  agendamentoTratamento?: number;
  ehDeHoje?: boolean;
};

const Odonto = ({
  paciente,
  dadosAgendamento,
  medUsuCodigo,
  finalizado,
  buscaOutrosMedicos,
  bloqueado,
  idTratamento,
  agendamentoTratamento,
  ehDeHoje,
}: IProps): JSX.Element => {
  const { addToast } = useToast();
  const { user } = useAuth();

  const [tratamento, setTratamento] = useState<ITratamentoDente[]>([]);
  const [modalAssinaturaAberto, setModalAssinaturaAberto] = useState(false);
  const [secoes, setSecoes] = useState<number>(1);
  const formRefPaciente = useRef<FormHandles>(null);
  const [pacienteResponsavelID, setPacienteResponsavelID] = useState<number>(
    dadosAgendamento.pacienteID,
  );

  const [tratamentoID, setTratamentoID] = useState<number | undefined>(
    idTratamento,
  );

  const [
    pacienteResponsavel,
    setPacienteResponsavel,
  ] = useState<IPacienteCodigo>();

  const [pacienteContrato, setPacienteContrato] = useState<IPacienteContrato>(
    paciente,
  );

  const [orcamentoCadastrado, setOrcamentoCadastrado] = useState<
    IOrcamento | undefined
  >(undefined);

  const [orcamentoAlterado, setOrcamentoAlterado] = useState(false);

  const [loading, setLoading] = useState(false);

  const [showEvolucao, setShowEvolucao] = useState(false);
  const [formaPagamento, setFormaPagamento] = useState('');

  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    async function loadDadosOrcamento(): Promise<void> {
      setLoading(true);
      try {
        const MedUsuCodigo =
          medUsuCodigo && !buscaOutrosMedicos
            ? `&MedUsuCodigo=${medUsuCodigo}`
            : '';

        const Finalizado =
          finalizado !== undefined ? `&finalizado=${finalizado === true}` : '';

        const resposta = await api.get<IOrcamento>(
          `/tratamento/paciente/${dadosAgendamento.pacienteID}?tipo=${TIPO_TRATAMENTO.ODONTOLOGIA}${MedUsuCodigo}${Finalizado}`,
        );

        setOrcamentoCadastrado(resposta.data);
        if (resposta.data.PacCodigoResponsavel)
          setPacienteResponsavelID(resposta.data.PacCodigoResponsavel);

        setFormaPagamento(resposta.data.formaPagamento);

        const tratatmentoDente: ITratamentoDente[] = resposta.data.procedimentosTratamento.map(
          proc => {
            return {
              chave: `${proc.dente}-${proc.ProCodigo.toString()}`,
              ProCodigo: proc.ProCodigo,
              dente: proc.dente,
              ProDuracao: 10,
              ProNome: proc.ProNome,
              ProValor: proc.valor,
              ProValorFormatado: formatPrice(proc.valor),
            };
          },
        );
        setTratamento(tratatmentoDente);

        setSecoes(resposta.data.secoes);
      } catch (error) {
        console.log('nenhum tratamento');
      } finally {
        setLoading(false);
      }
    }
    if (!idTratamento && !agendamentoTratamento) loadDadosOrcamento();
  }, [
    addToast,
    dadosAgendamento.pacienteID,
    finalizado,
    medUsuCodigo,
    buscaOutrosMedicos,
    idTratamento,
    agendamentoTratamento,
  ]);

  const temResponsavel = useMemo(() => {
    return (
      orcamentoCadastrado &&
      orcamentoCadastrado.PacCodigo !== pacienteResponsavelID
    );
  }, [orcamentoCadastrado, pacienteResponsavelID]);

  useEffect(() => {
    async function loadDadosReponsavel(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get(`/pacientes/${pacienteResponsavelID}`);
        const responsePaciente: IPacienteCodigo = response.data;

        setPacienteResponsavel({
          ...responsePaciente,
          PacTelefone: formataTelefone(responsePaciente.PacTelefone),
          PacCelular: formataTelefone(responsePaciente.PacCelular),
          PacCPF: formataCPF(responsePaciente.PacCPF),
          PacDataNascFormatada: format(
            parseISO(responsePaciente.PacDataNasc),
            'dd/MM/yyyy',
          ),
          PacIdade: formataIdade(parseISO(responsePaciente.PacDataNasc)),
          avatar_url: responsePaciente.avatar_url,
        });

        setPacienteContrato({
          PacCodigo: responsePaciente.PacCodigo,
          PacCPF: formataCPF(responsePaciente.PacCPF),
          PacNome: responsePaciente.PacNome,
          PacNomeSocial: responsePaciente.PacNomeSocial,
          PacEmail: responsePaciente.PacEmail,
        });
      } catch (error) {
        addToast({
          title: 'Não foi possível buscar o responsável',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
    if (temResponsavel) loadDadosReponsavel();
  }, [temResponsavel, addToast, pacienteResponsavelID]);

  const plano = useMemo(() => {
    return orcamentoCadastrado?.plano || dadosAgendamento.agePlano;
  }, [orcamentoCadastrado, dadosAgendamento.agePlano]);

  const contrato = useMemo(() => {
    return orcamentoCadastrado?.contrato;
  }, [orcamentoCadastrado?.contrato]);

  useEffect(() => {
    async function loadDadosAgendamentos(): Promise<void> {
      setLoading(true);
      try {
        const resposta = await api.get<IOrcamento>(
          `/tratamento/${idTratamento}`,
        );

        setOrcamentoCadastrado(resposta.data);
        setFormaPagamento(resposta.data.formaPagamento);
        setPacienteResponsavelID(resposta.data.PacCodigoResponsavel);

        const tratatmentoDente: ITratamentoDente[] = resposta.data.procedimentosTratamento.map(
          proc => {
            return {
              chave: `${proc.dente}-${proc.ProCodigo.toString()}`,
              ProCodigo: proc.ProCodigo,
              dente: proc.dente,
              ProDuracao: 10,
              ProNome: proc.ProNome,
              ProValor: proc.valor,
              ProValorFormatado: formatPrice(proc.valor),
              finalizado: proc.finalizado,
            };
          },
        );
        setTratamento(tratatmentoDente);

        setSecoes(resposta.data.secoes);
      } catch (error) {
        addToast({
          title: 'Não foi possível buscar o agendamento',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
    if (idTratamento) loadDadosAgendamentos();
  }, [addToast, idTratamento]);

  useEffect(() => {
    async function loadDadosAgendamentos(): Promise<void> {
      setLoading(true);
      try {
        const resposta = await api.get<IOrcamento>(
          `/tratamento/agendamento/${agendamentoTratamento}`,
        );

        setOrcamentoCadastrado(resposta.data);
        setFormaPagamento(resposta.data.formaPagamento);
        setPacienteResponsavelID(resposta.data.PacCodigoResponsavel);
        setTratamentoID(resposta.data.id);

        const tratatmentoDente: ITratamentoDente[] = resposta.data.procedimentosTratamento.map(
          proc => {
            return {
              chave: `${proc.dente}-${proc.ProCodigo.toString()}`,
              ProCodigo: proc.ProCodigo,
              dente: proc.dente,
              ProDuracao: 10,
              ProNome: proc.ProNome,
              ProValor: proc.valor,
              ProValorFormatado: formatPrice(proc.valor),
              procedimentoEvolucao: proc.procedimentoEvolucao.map(ev => {
                return {
                  ...ev,
                  dataFormatada: format(
                    parseISO(ev.created_at.toString()),
                    'dd/MM/yyyy',
                  ),
                };
              }),
              id: proc.id,
              finalizado: proc.finalizado,
            };
          },
        );
        setTratamento(tratatmentoDente);

        setSecoes(resposta.data.secoes);
      } catch (error) {
        addToast({
          title: 'Não foi possível buscar o agendamento',
          type: 'error',
        });
      } finally {
        setLoading(false);
      }
    }
    if (agendamentoTratamento) loadDadosAgendamentos();
  }, [addToast, agendamentoTratamento]);

  const handleRemoveProcedimentoDente = useCallback(
    (chave: string) => {
      setTratamento(state => state.filter(pro => pro.chave !== chave));
      if (orcamentoCadastrado) setOrcamentoAlterado(true);
    },
    [orcamentoCadastrado],
  );

  const total = useMemo(() => {
    const valor = tratamento.reduce((tot, prod) => {
      return tot + Number(prod.ProValor);
    }, 0);
    return {
      duracao: tratamento.reduce((tot, prod) => {
        return tot + Number(prod.ProDuracao);
      }, 0),
      valor,
      valorFormatado: formatPrice(valor),
    };
  }, [tratamento]);

  const valorParcela = useMemo(() => {
    return formatPrice(total.valor / secoes);
  }, [secoes, total.valor]);

  const handleAddTratamento = useCallback(async () => {
    if (tratamento.length === 0) {
      addToast({ type: 'info', title: 'Nenhum procedimento adicionado' });
      return;
    }
    setLoading(true);
    try {
      const dadosTratamento = {
        MedUsuCodigo: user.UsuCodigo,
        PacCodigo: dadosAgendamento.pacienteID,
        tipo: TIPO_TRATAMENTO.ODONTOLOGIA,
        valor: total.valor,
        secoes,
      };

      const dadosProcedimentos = tratamento.map(trat => {
        return {
          dente: trat.dente,
          ProCodigo: trat.ProCodigo,
          ProNome: trat.ProNome,
          valor: trat.ProValor,
        };
      });

      if (!orcamentoCadastrado) {
        const response = await api.post<IOrcamento>(`/tratamento`, {
          ...dadosTratamento,
          procedimentosTratamento: dadosProcedimentos,
          AgeCodigo: dadosAgendamento.AgeCodigo,
          plano,
        });
        setOrcamentoCadastrado(response.data);
      } else {
        const responseUpdate = await api.put<IOrcamento>(
          `/tratamento/${orcamentoCadastrado.id}`,
          {
            ...dadosTratamento,
            id: orcamentoCadastrado.id,
            procedimentosTratamento: dadosProcedimentos,
            MedUsuCodigo: undefined,
            formaPagamento,
            PacCodigoResponsavel: pacienteResponsavelID,
          },
        );
        setOrcamentoCadastrado({ ...dadosTratamento, ...responseUpdate.data });
      }

      setOrcamentoAlterado(false);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Erro ao salvar Orçamento/Tratamento',
        type: 'error',
        description: mensagemErro,
        timeAlive: 10000,
      });
    } finally {
      setLoading(false);
    }
  }, [
    tratamento,
    addToast,
    dadosAgendamento,
    plano,
    total.valor,
    user.UsuCodigo,
    orcamentoCadastrado,
    secoes,
    formaPagamento,
    pacienteResponsavelID,
  ]);

  const handleFecharContrato = useCallback(async () => {
    setLoading(true);
    try {
      const responseContrato = await api.put<IContrato>(
        `/tratamento/${orcamentoCadastrado?.id}/geraContrato`,
        {
          ConOrigem: 1, // tratamento Odontologico
        },
      );
      setOrcamentoCadastrado(state => {
        return (
          state && {
            ...state,
            contrato: responseContrato.data,
            orcamento: false,
          }
        );
      });
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Erro ao salvar Gerar Contrato',
        type: 'error',
        description: mensagemErro,
        timeAlive: 10000,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, orcamentoCadastrado]);

  const handleAddTratamentoDente = useCallback(
    async (dados: ITratamentoDente) => {
      setTratamento(state => [...state, dados]);
      if (orcamentoCadastrado) setOrcamentoAlterado(true);
    },
    [orcamentoCadastrado],
  );

  const handleEvolucao = useCallback((idProcedimento: number) => {
    setProcedimentoSelecionado(idProcedimento);
    setShowEvolucao(true);
  }, []);

  const handleEditouEvolucao = useCallback(
    (evo: IProcedimentoEvolucao, operacao: 'add' | 'edit' | 'remove'): void => {
      if (operacao === 'remove') {
        setTratamento(state =>
          state.map(trat => {
            if (trat.id === evo.idProcedimento) {
              const evols = trat.procedimentoEvolucao?.filter(
                ev => ev.id !== evo.id,
              );
              return { ...trat, procedimentoEvolucao: evols };
            }
            return trat;
          }),
        );
        return;
      }
      if (operacao === 'add') {
        setTratamento(state =>
          state.map(trat => {
            if (trat.id === evo.idProcedimento) {
              return {
                ...trat,
                procedimentoEvolucao: trat.procedimentoEvolucao
                  ? [...trat.procedimentoEvolucao, evo]
                  : [evo],
              };
            }
            return trat;
          }),
        );
      }
      if (operacao === 'edit') {
        setTratamento(state =>
          state.map(trat => {
            if (trat.id === evo.idProcedimento) {
              const evols = trat.procedimentoEvolucao?.filter(
                ev => ev.id !== evo.id,
              );
              return {
                ...trat,
                procedimentoEvolucao: evols ? [...evols, evo] : [evo],
              };
            }
            return trat;
          }),
        );
      }
    },
    [],
  );

  const handleSubmitPaciente = useCallback(() => {
    console.log('foi');
  }, []);

  const handleSelectClienteChange = useCallback(({ value, label }) => {
    if (value && value !== '') {
      setPacienteResponsavelID(Number(value));
      setOrcamentoAlterado(true);
    }
  }, []);

  const handleFinalizaProcedimento = useCallback(
    async (idProcedimento: number) => {
      setLoading(true);
      try {
        const responseFinalizado = await api.patch<boolean>(
          `/tratamento/procedimento/${idProcedimento}`,
        );

        setTratamento(state => {
          return (
            state &&
            state.map(proc => {
              const procedimentoFinalizado =
                proc.id === idProcedimento
                  ? responseFinalizado.data
                  : proc.finalizado;
              return {
                ...proc,
                finalizado: procedimentoFinalizado,
              };
            })
          );
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Erro ao finalizar procedimento',
          type: 'error',
          description: mensagemErro,
          timeAlive: 10000,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast],
  );

  const handleFinalizarTratamento = useCallback(async () => {
    setLoading(true);
    try {
      const responseFinalizado = await api.patch<boolean>(
        `/tratamento/${tratamentoID}`,
      );

      setOrcamentoCadastrado(state => {
        return (
          state && {
            ...state,
            finalizado: responseFinalizado.data,
          }
        );
      });
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Erro ao finalizar procedimento',
        type: 'error',
        description: mensagemErro,
        timeAlive: 10000,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, tratamentoID]);

  const exibeOdontograma = useMemo(() => {
    return (
      !buscaOutrosMedicos ||
      agendamentoTratamento ||
      (buscaOutrosMedicos &&
        (!orcamentoCadastrado ||
          (orcamentoCadastrado.MedUsuCodigo === medUsuCodigo &&
            orcamentoCadastrado.orcamento === true)))
    );
  }, [
    agendamentoTratamento,
    buscaOutrosMedicos,
    orcamentoCadastrado,
    medUsuCodigo,
  ]);

  const possoEvoluir = useMemo(() => {
    return orcamentoCadastrado && !orcamentoCadastrado.finalizado && ehDeHoje;
  }, [orcamentoCadastrado, ehDeHoje]);

  const agendamentos = useMemo(() => {
    if (!orcamentoCadastrado?.agendamentosTratamento)
      return { atendidos: false, agendas: [] };
    return {
      agendas: orcamentoCadastrado.agendamentosTratamento.map(age => {
        return age.agenda;
      }),
      atendidos:
        orcamentoCadastrado.agendamentosTratamento.filter(
          ages => ages.agenda.AgeStatus !== STATUS_AGENDA.ATENDIDO,
        ).length === 0,
    };
  }, [orcamentoCadastrado]);

  const possoFinalizar = useMemo(() => {
    return (
      loading ||
      (orcamentoCadastrado &&
        !orcamentoCadastrado.finalizado &&
        tratamento.filter(procs => procs.finalizado === false).length === 0 &&
        (orcamentoCadastrado.formaPagamento !== TIPO_PAGAMENTO.PARCELAMENTO ||
          agendamentos.atendidos))
    );
  }, [loading, orcamentoCadastrado, tratamento, agendamentos.atendidos]);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      {showEvolucao && procedimentoSelecionado && (
        <Modal
          show={showEvolucao}
          titulo="Adicionar Evolução"
          handleFecharModal={
            () => {
              setProcedimentoSelecionado(undefined);
              setShowEvolucao(false);
            }
            // eslint-disable-next-line react/jsx-curly-newline
          }
        >
          <Evolucao
            evolucoes={
              tratamento.find(trat => trat.id === procedimentoSelecionado)
                ?.procedimentoEvolucao
            }
            procedimentoId={procedimentoSelecionado}
            bloqueado={!possoEvoluir}
            handleEditouEvolucao={handleEditouEvolucao}
            medUsuCodigo={medUsuCodigo}
          />
        </Modal>
      )}
      <Container className="pt-2">
        {exibeOdontograma && (
          <>
            <Row>
              <Col md={8} lg={8}>
                <div className="border rounded">
                  <OdontoGrama
                    agePlano={plano}
                    pacienteID={dadosAgendamento.pacienteID}
                    AgeCodigo={dadosAgendamento.AgeCodigo}
                    addTratamento={handleAddTratamentoDente}
                    bloqueado={
                      bloqueado ||
                      (orcamentoCadastrado !== undefined &&
                        !orcamentoCadastrado.orcamento)
                    }
                  />
                </div>

                <Row>
                  <Col>
                    <div>
                      {tratamento && tratamento.length > 0 && (
                        <Table
                          className="table table-hover table-sm"
                          id="GrdProcedimentos"
                          style={{ borderWidth: '0px', marginTop: '-2px' }}
                        >
                          <tbody>
                            <tr
                              className="bg-light"
                              style={{ fontSize: 'Small' }}
                            >
                              <th scope="col">Dente</th>
                              <th scope="col">Tratamento</th>
                              <th scope="col">Valor</th>
                              {agendamentoTratamento && (
                                <>
                                  <th scope="col">Evolução</th>
                                  <th scope="col">Finalizado</th>
                                </>
                              )}
                              {!bloqueado &&
                                (orcamentoCadastrado === undefined ||
                                  orcamentoCadastrado?.orcamento) && (
                                  <th scope="col">Excluir</th>
                                )}
                              <th className="d-none" scope="col">
                                Status
                              </th>
                            </tr>
                            {tratamento.map(proced => (
                              <tr
                                key={`${proced.dente}-${proced.ProCodigo}`}
                                style={{ fontSize: 'Small' }}
                              >
                                <td style={{ width: '100px' }}>
                                  {proced.dente}
                                </td>
                                <td>{proced.ProNome}</td>
                                <td style={{ width: '80px' }}>
                                  {proced.ProValorFormatado}
                                </td>
                                {agendamentoTratamento && (
                                  <>
                                    <td
                                      className="w3-padding-0"
                                      style={{ width: '40px' }}
                                    >
                                      <Button
                                        type="button"
                                        size="sm"
                                        onClick={
                                          () => handleEvolucao(proced.id || 0)
                                          // eslint-disable-next-line react/jsx-curly-newline
                                        }
                                      >
                                        <FaBars />(
                                        {proced.procedimentoEvolucao?.length})
                                      </Button>
                                    </td>
                                    <td
                                      className="w3-padding-0"
                                      style={{ width: '60px' }}
                                    >
                                      <Button
                                        type="button"
                                        size="sm"
                                        variant={`${
                                          proced.finalizado
                                            ? 'primary'
                                            : 'outline-primary'
                                        }`}
                                        disabled={
                                          proced.procedimentoEvolucao
                                            ?.length === 0
                                        }
                                        onClick={
                                          () =>
                                            handleFinalizaProcedimento(
                                              proced.id || 0,
                                            )
                                          // eslint-disable-next-line react/jsx-curly-newline
                                        }
                                      >
                                        {proced.finalizado ? 'Sim' : 'Não'}
                                      </Button>
                                    </td>
                                  </>
                                )}

                                {!bloqueado &&
                                  (orcamentoCadastrado === undefined ||
                                    orcamentoCadastrado?.orcamento) && (
                                    <td
                                      className="w3-padding-0"
                                      style={{ width: '40px' }}
                                    >
                                      <Button
                                        type="button"
                                        variant="outline-danger"
                                        size="sm"
                                        onClick={() => {
                                          handleRemoveProcedimentoDente(
                                            proced.chave,
                                          );
                                        }}
                                        disabled={bloqueado}
                                      >
                                        <FaTrashAlt />
                                      </Button>
                                    </td>
                                  )}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col md={4} lg={4}>
                <div className="p-2 border rounded">
                  <h5>Valor Total</h5>
                  <div className="d-flex justify-content-around text-primary mb-2">
                    <div>
                      <b style={{ fontSize: '25px' }}>{total.valorFormatado}</b>
                    </div>
                  </div>
                </div>
                <br />
                <div className="p-2 border rounded">
                  {agendamentoTratamento === undefined && (
                    <>
                      <Row className="d-print-none">
                        <Col md={6} lg={6}>
                          <b style={{ marginBottom: '4px', display: 'block' }}>
                            Nº Parcelas / Seções
                          </b>
                          <div className="d-flex">
                            <Button
                              type="button"
                              size="sm"
                              variant="outline-info"
                              onClick={() => {
                                // eslint-disable-next-line prettier/prettier
                                setSecoes(state =>
                                  state > 1 ? state - 1 : state,
                                );
                                setOrcamentoAlterado(true);
                              }}
                              disabled={
                                (contrato !== null && contrato !== undefined) ||
                                (orcamentoCadastrado &&
                                  orcamentoCadastrado.orcamento === false)
                              }
                            >
                              <FaMinusCircle />
                            </Button>
                            <input
                              type="number"
                              name="secoes"
                              value={secoes}
                              disabled
                              style={{
                                width: '100%',
                                borderRadius: '5px',
                                border: '1px solid rgb(206, 212, 218)',
                                backgroundColor: 'rgb(255, 255, 255)',
                                display: 'flex',
                                alignItems: 'center',
                                paddingLeft: '14px',
                                textAlign: 'center',
                                marginLeft: '4px',
                                marginRight: '4px',
                              }}
                            />
                            <Button
                              type="button"
                              size="sm"
                              variant="outline-info"
                              onClick={
                                () => {
                                  setSecoes(state =>
                                    state < 6 ? state + 1 : state,
                                  );
                                  setOrcamentoAlterado(true);
                                }
                                // eslint-disable-next-line react/jsx-curly-newline
                              }
                              disabled={
                                (contrato !== null && contrato !== undefined) ||
                                (orcamentoCadastrado &&
                                  orcamentoCadastrado.orcamento === false)
                              }
                            >
                              <FaPlusCircle />
                            </Button>
                          </div>
                        </Col>
                        <Col md={6} lg={6} className="text-left">
                          <b style={{ marginBottom: '4px', display: 'block' }}>
                            Forma de Pagamento
                          </b>

                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              checked={formaPagamento === TIPO_PAGAMENTO.AVISTA}
                              onClick={() => {
                                setFormaPagamento(TIPO_PAGAMENTO.AVISTA);
                                setOrcamentoAlterado(true);
                              }}
                              disabled={
                                (contrato !== null && contrato !== undefined) ||
                                (orcamentoCadastrado &&
                                  orcamentoCadastrado.orcamento === false)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              {TIPO_PAGAMENTO.AVISTA}
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault2"
                              checked={formaPagamento === TIPO_PAGAMENTO.CARTAO}
                              onClick={() => {
                                setFormaPagamento(TIPO_PAGAMENTO.CARTAO);
                                setOrcamentoAlterado(true);
                              }}
                              disabled={
                                (contrato !== null && contrato !== undefined) ||
                                (orcamentoCadastrado &&
                                  orcamentoCadastrado.orcamento === false)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault2"
                            >
                              {TIPO_PAGAMENTO.CARTAO}
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault2"
                              checked={
                                formaPagamento === TIPO_PAGAMENTO.PARCELAMENTO
                              }
                              onClick={() => {
                                setFormaPagamento(TIPO_PAGAMENTO.PARCELAMENTO);
                                setOrcamentoAlterado(true);
                              }}
                              disabled={
                                (contrato !== null && contrato !== undefined) ||
                                (orcamentoCadastrado &&
                                  orcamentoCadastrado.orcamento === false)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault2"
                            >
                              {TIPO_PAGAMENTO.PARCELAMENTO}
                            </label>
                          </div>
                        </Col>
                      </Row>
                      <div
                        className={`${
                          formaPagamento !== TIPO_PAGAMENTO.PARCELAMENTO
                            ? 'd-none'
                            : ''
                        }`}
                      >
                        <h5>simulação</h5>
                        <div className="d-flex justify-content-around  mb-2">
                          <span>Valor Parcela:</span>
                          <b>{valorParcela}</b>
                        </div>
                      </div>
                    </>
                  )}
                  {agendamentoTratamento !== undefined && (
                    <>
                      <Row className="d-print-none">
                        <Col md={6} lg={6}>
                          <b style={{ marginBottom: '4px', display: 'block' }}>
                            Nº Seções
                          </b>
                        </Col>
                        <Col md={6} lg={6}>
                          <b
                            style={{
                              marginBottom: '4px',
                              display: 'block',
                              fontSize: '1.3rem',
                            }}
                          >
                            {secoes}
                          </b>
                        </Col>
                      </Row>
                    </>
                  )}
                </div>

                {bloqueado && (
                  <>
                    <div className="bg-white border rounded p-2 mt-2">
                      <b style={{ marginBottom: '4px', display: 'block' }}>
                        Responsável pelo contrato
                      </b>
                      {!temResponsavel && (
                        <span>
                          <b>O próprio</b>
                        </span>
                      )}
                      {temResponsavel && pacienteResponsavel && (
                        <div style={{ padding: '0.5rem' }}>
                          <span>
                            Nome: <b>{pacienteResponsavel.PacNome}</b>
                          </span>
                          <br />
                          <span>
                            CPF: <b>{pacienteResponsavel.PacCPF}</b>
                          </span>
                          <br />
                          <span>
                            Telefone:
                            <b>
                              {formataTelefone(pacienteResponsavel.PacTelefone)}
                              {formataTelefone(pacienteResponsavel.PacCelular)}
                            </b>
                          </span>
                        </div>
                      )}
                      {orcamentoCadastrado?.orcamento && (
                        <>
                          {loading && <Loading backgroundBlack={false} />}
                          <Form
                            ref={formRefPaciente}
                            style={{ padding: '.5rem' }}
                            onSubmit={handleSubmitPaciente}
                          >
                            <SelectAsync
                              name="pacienteResponsavelID"
                              label=""
                              urlApi="pacientes/combo?termoBusca="
                              placeholder="Digite para buscar"
                              handleSelectChange={handleSelectClienteChange}
                            />
                          </Form>
                        </>
                      )}
                    </div>
                  </>
                )}
                <div className="p-2 ">
                  <Row className="mb-3">
                    <Col
                      md={12}
                      lg={12}
                      className="d-flex justify-content-between"
                    >
                      <Button
                        type="button"
                        style={{ marginTop: '21px' }}
                        variant="info"
                        onClick={() => handleAddTratamento()}
                        disabled={
                          loading || (orcamentoCadastrado && !orcamentoAlterado)
                        }
                        className={`${
                          contrato || orcamentoCadastrado?.orcamento === false
                            ? 'd-none'
                            : ''
                        }`}
                      >
                        {loading ? (
                          <Spinner>
                            <FaSpinner />
                          </Spinner>
                        ) : (
                          'Salvar Orçamento'
                        )}
                      </Button>

                      <Button
                        type="button"
                        style={{ marginTop: '21px' }}
                        variant="info"
                        onClick={() => handleFecharContrato()}
                        disabled={
                          loading ||
                          (contrato !== null && contrato !== undefined) ||
                          orcamentoAlterado
                        }
                        className={`${
                          contrato ||
                          !orcamentoCadastrado ||
                          orcamentoCadastrado?.orcamento === false ||
                          !bloqueado
                            ? 'd-none'
                            : ''
                        }`}
                      >
                        {loading ? (
                          <Spinner>
                            <FaSpinner />
                          </Spinner>
                        ) : (
                          'Fechar Contrato'
                        )}
                      </Button>
                      {contrato && (
                        <>
                          {!contrato.ConAssinado && (
                            <div>
                              <Link
                                className="btn btn-outline-primary "
                                to={`/contratotratamento/${contrato.ConCodigo}`}
                                target="_blank"
                              >
                                <FaPrint />
                              </Link>
                            </div>
                          )}
                          <div>
                            <Button
                              type="button"
                              variant="info"
                              onClick={() => setModalAssinaturaAberto(true)}
                            >
                              <FaPencilAlt />{' '}
                              {contrato.ConAssinado
                                ? 'Ver Assinatura'
                                : 'Assinar Contrato'}
                            </Button>
                          </div>
                          <div className={`${bloqueado ? 'd-none' : ''}`}>
                            <Button
                              type="button"
                              style={{ marginTop: '21px' }}
                              variant="info"
                              onClick={() => handleFinalizarTratamento()}
                              disabled={!possoFinalizar}
                            >
                              {orcamentoCadastrado?.finalizado
                                ? 'Tratamento Finalizado'
                                : 'Finalizar Tratamento'}
                            </Button>
                          </div>
                        </>
                      )}
                    </Col>
                  </Row>
                </div>
                {contrato && orcamentoCadastrado && (
                  <div className="p-2 border rounded">
                    <AgendamentosTratamento
                      bloqueado={bloqueado}
                      agendamentoTratamento={agendamentoTratamento}
                      idTratamento={orcamentoCadastrado.id}
                      agendamentosIniciais={agendamentos.agendas}
                      secoes={orcamentoCadastrado.secoes}
                      valor={orcamentoCadastrado.valor}
                      finalizado={orcamentoCadastrado.finalizado}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </>
        )}
        {!exibeOdontograma && (
          <>
            <br />
            <br />
            <h3>Já existe um tratamento em andamento ou orçamento em aberto</h3>
            <br />
            <br />
          </>
        )}
        {contrato &&
          pacienteContrato &&
          modalAssinaturaAberto &&
          orcamentoCadastrado && (
            <ModalAssinaturaContrato
              contrato={contrato}
              paciente={pacienteContrato}
              medico={{
                UsuCodigo: orcamentoCadastrado.medico.UsuCodigo,
                UsuNome: orcamentoCadastrado.medico.UsuNome,
                UsuEmail: orcamentoCadastrado.medico.UsuEmail,
              }}
              show={modalAssinaturaAberto}
              onClose={() => setModalAssinaturaAberto(false)}
              onAssinaturaIniciada={() => window.location.reload()}
            />
          )}
      </Container>
    </>
  );
};

export default Odonto;
